export enum BackendEnum {
    All = 'todos',
    Bimer = 1,
    Shop = 2,
    Interfacenet = 3,
}
